import "./styles.css";
import { installOutboundLog } from "./system/outbound.js";
import { App } from "./app/app.js";
import { loadDevice, saveDevice } from "./app/device.js";
import { h } from "./ui/dom.js";
import { mountGallery, mountPlaces } from "./ui/gallery.js";
import { connectView } from "./ui/settings.js";

// Before anything talks to the network: record everything this device sends (Settings → Co wysłałem).
installOutboundLog();

const root = document.querySelector<HTMLDivElement>("#app")!;
const params = new URLSearchParams(location.search);

declare global {
  interface Window {
    squire?: App;
  }
}

// Installable PWA on the web; the Android app serves files locally and needs no service worker.
if (import.meta.env.PROD && "serviceWorker" in navigator && !(window as { Capacitor?: unknown }).Capacitor)
  void navigator.serviceWorker.register("./sw.js").catch(() => {});

if (params.get("debug") === "anim") {
  mountGallery(root, { skin: 1, hair: 0, hairColor: 1, beard: 1, glasses: false, shirt: 0 });
} else if (params.get("debug") === "places") {
  mountPlaces(root, { skin: 1, hair: 0, hairColor: 1, beard: 1, glasses: false, shirt: 0 });
} else {
  const device = loadDevice();
  const run = () => {
    const app = new App(root, device, { headless: params.get("headless") === "1" });
    window.squire = app;
    void app.start();
  };
  if (device.local || (device.serverUrl && device.token)) run();
  else {
    const screen = h(
      "div",
      { class: "overlay" },
      h(
        "div",
        { class: "frame" },
        h("h1", { style: { marginBottom: "0.6em" } }, "Squire"),
        connectView(
          device,
          (url, token) => {
            device.serverUrl = url;
            device.token = token;
            device.local = false;
            saveDevice(device);
            screen.remove();
            run();
          },
          () => {
            device.local = true;
            saveDevice(device);
            screen.remove();
            run();
          },
        ),
      ),
    );
    root.append(screen);
  }
}
